// Action types for Redux reducers

export const ACTION_DOCTOR_APPOINTMENTS = {
  fetch_doctor_appointments: "fetch_doctor_appointments",
  join_appointment: "join_appointment",
  fetch_doctor_consultation_pricing: "fetch_doctor_consultation_pricing",
  update_consultation_fee: "update_consultation_fee",
};

export const ACTION_CONSULTATION = {
  fetch_consultation: "fetch_consultation",
};

export const ACTION_DOCTOR_PERSONAL_INFO = {
  update_doctor_personal_info: "update_doctor_personal_info",
};

export const ACTION_DOCTOR_CLINIC_SCHEDULE = {
  update_doctor_clinic_schedule: "update_doctor_clinic_schedule",
};

export const ACTION_DOCTOR_EMERGENCY_SCHEDULE = {
  update_doctor_midnight_schedule: "update_doctor_midnight_schedule",
};

export const ACTION_DOCTOR_EMERGENCY_HOME_VISIT_SCHEDULE = {
  update_doctor_midnight_home_visit_schedule:
    "update_doctor_midnight_home_visit_schedule",
};

export const ACTION_DOCTOR_WALLET = {
  fetch_doctor_wallet: "fetch_doctor_wallet",
  fetch_doctor_wallet_transactions: "fetch_doctor_wallet_transactions",
  fetch_doctor_wallet_unified_transactions:
    "fetch_doctor_wallet_unified_transactions",
  withdraw_doctor_wallet: "withdraw_doctor_wallet",
  fetch_wallet_withdrawals: "fetch_wallet_withdrawals",
};

export const ACTION_PAYOUT_ACCOUNT = {
  fetch_default_payout_account: "fetch_default_payout_account",
  save_payout_account: "save_payout_account",
  submit_settlement_request: "submit_settlement_request",
  fetch_provider_settlements: "fetch_provider_settlements",
  fetch_provider_dashboard: "fetch_provider_dashboard",
};

export const ACTION_DOCTOR_DOCUMENTS = {
  fetch_documents: "fetch_documents",
};

export const ACTION_PATIENT_REGISTER = {
  patient_register: "patient_register",
};

export const ACTION_PATIENT_APP_LINK = {
  send_app_link: "send_patient_app_link",
};

export const POST_FORGOT_PASSWORD = {
  forgot_password: "forgot_password",
};

export const ACTIONS_VERIFY_OTP = {
  verify_otp: "verify_otp",
  resend_otp: "resend_otp",
};

export const ACTIONS_VERIFY_CLAIM = {
  verify_claim: "verify_claim",
};

export const ACTIONS_GET_CLAIM_BY_ID = {
  get_claim_by_id: "get_claim_by_id",
};

export const ACTIONS_APPROVE_CLAIM_ITEM = {
  approve_claim_item: "approve_claim_item",
};

export const ACTIONS_CALCULATE_CLAIM = {
  calculate_claim: "calculate_claim",
};

export const ACTIONS_GET_CLAIM_DOCUMENTS = {
  get_claim_documents: "get_claim_documents",
};

export const ACTIONS_GET_HISTORY = {
  get_history: "get_history",
};

export const ACTIONS_REJECT_CLAIM = {
  reject_claim: "reject_claim",
};

export const ACTIONS_REJECT_CLAIM_ITEM = {
  reject_claim_item: "reject_claim_item",
};

export const ACTIONS_EXPORT_CLAIMS = {
  export_claims: "export_claims",
};

export const ACTIONS_UPDATE_INVOICE = {
  update_invoice: "update_invoice",
};

export const ACTIONS_COMPLETE_APPOINTMENT_WITH_ACTION = {
  complete_appointment_with_action: "complete_appointment_with_action",
};

export const ACTIONS_CONFIRM_PHARMACY_ORDER = {
  confirm_order: "confirm_pharmacy_order",
};

export const ACTIONS_REJECT_PHARMACY_ORDER = {
  reject_order: "reject_pharmacy_order",
};

export const ACTIONS_APPROVE_PHARMACY_ORDER = {
  approve_order: "approve_pharmacy_order",
};

export const ACTIONS_DOCTOR_APPOINTMENTS_PATIENTS = {
  get_doctor_appointments_patients: "get_doctor_appointments_patients",
};

export const ACTIONS_GET_APPOINTMENT_BY_ID = {
  get_appointment_by_id: "get_appointment_by_id",
};

export const ACTIONS_DOCTOR_HOME_VISIT_REQUESTS = {
  get_doctor_home_visit_requests: "get_doctor_home_visit_requests",
  get_doctor_home_visit_requests_recent:
    "get_doctor_home_visit_requests_recent",
  fetch_requests: "fetch_doctor_home_visit_requests",
  fetch_recent_requests: "fetch_doctor_upcoming_appointments",
};

export const ACTIONS_CREATE_FOLLOWUP_APPOINTMENT = {
  create_followup_appointment: "create_followup_appointment",
};

export const ACTIONS_REQUEST_APPOINTMENT_RESCHEDULE = {
  request_appointment_reschedule: "request_appointment_reschedule",
};

export const ACTIONS_UPDATE_HOME_VISIT_SCHEDULE = {
  update_home_visit_schedule: "update_home_visit_schedule",
};

export const ACTIONS_UPDATE_HOME_VISIT_ONLINE = {
  update_home_visit_online: "update_home_visit_online",
};

export const ACTIONS_UPDATE_EMERGENCY_ONLINE = {
  update_midnight_online: "update_midnight_online",
};

export const ACTIONS_UPDATE_EMERGENCY_HOME_VISIT_ONLINE = {
  update_midnight_home_visit_online: "update_midnight_home_visit_online",
};

export const ACTIONS_GET_PHARMACY_ORDERS = {
  get_pharmacy_orders: "get_pharmacy_orders",
};

export const ACTIONS_GET_PHARMACY_RECENT_ORDERS = {
  get_pharmacy_recent_orders: "get_pharmacy_recent_orders",
};

export const ACTIONS_GET_PHARMACY_ORDERS_HISTORY = {
  get_pharmacy_orders_history: "get_pharmacy_orders_history",
};

export const ACTIONS_GET_PHARMACY_CART_ORDER_REQUESTS = {
  get_pharmacy_cart_order_requests: "get_pharmacy_cart_order_requests",
};

export const ACTIONS_SEARCH_PHARMACY_MEDICINES = {
  search_pharmacy_medicines: "search_pharmacy_medicines",
};

export const ACTIONS_SEARCH_PHARMACY_MEDICINES_AND_COSMETICS = {
  search_pharmacy_medicines_and_cosmetics:
    "search_pharmacy_medicines_and_cosmetics",
};

export const ACTIONS_GET_PHARMACY_PRODUCTS = {
  get_pharmacy_products: "get_pharmacy_products",
};

export const ACTIONS_UPLOAD_DOCTOR_AVATAR = {
  upload_doctor_avatar: "upload_doctor_avatar",
};

export const ACTIONS_UPLOAD_PRESCRIPTION = {
  upload_prescription: "upload_prescription",
};

export const ACTIONS_UPLOAD_DOCTOR_STAMP_SIGNATURE = {
  upload_doctor_stamp_signature: "upload_doctor_stamp_signature",
};

export const ACTIONS_SAVE_PRESCRIPTION = {
  save_prescription: "save_prescription",
};

export const ACTIONS_GET_PRESCRIPTION_BY_APPOINTMENT = {
  get_prescription_by_appointment: "get_prescription_by_appointment",
};

export const ACTIONS_GET_PATIENT_DETAILS = {
  get_patient_details: "get_patient_details",
};

export const ACTIONS_GET_PHARMACY_CATEGORIES = {
  get_pharmacy_categories: "get_pharmacy_categories",
};

export const ACTIONS_SEARCH_PHARMACY_MEDICINES_FOR_DOCTOR = {
  search_pharmacy_medicines_for_doctor: "search_pharmacy_medicines_for_doctor",
};

export const ACTIONS_SEARCH_LAB_TESTS = {
  search_lab_tests: "search_lab_tests",
};

export const ACTIONS_SEARCH_IMAGING_TESTS = {
  search_imaging_tests: "search_imaging_tests",
};

export const ACTIONS_SEARCH_PHYSIO_SERVICES = {
  search_physio_services: "search_physio_services",
};

export const ACTIONS_SEARCH_NURSE_SERVICES = {
  search_nurse_services: "search_nurse_services",
};

export const ACTIONS_ADDITIONAL_INCOME = {
  get_summary: "get_additional_income_summary",
  get_activities: "get_additional_income_activities",
};

export const ACTIONS_UPDATE_ONSITE_SCHEDULE = {
  update_onsite_schedule: "update_onsite_schedule",
};

// Doctor accepts / rejects an ONLINE (video) consultation request before the patient pays.
export const ACTIONS_UPDATE_ONLINE_DECISION = {
  update_online_decision: "update_online_decision",
};

export const ACTIONS_NOTIFICATIONS = {
  get_user_notifications: "get_user_notifications",
  mark_notification_read: "mark_notification_read",
  delete_notification: "delete_notification",
  get_unread_notification_count: "get_unread_notification_count",
  mark_all_notifications_read: "mark_all_notifications_read",
};

export const ACTIONS_PHARMACY_NOTIFICATIONS = {
  get_pharmacy_notifications: "get_pharmacy_notifications",
  mark_pharmacy_notification_read: "mark_pharmacy_notification_read",
  delete_pharmacy_notification: "delete_pharmacy_notification",
  get_pharmacy_unread_notification_count:
    "get_pharmacy_unread_notification_count",
  mark_all_pharmacy_notifications_read: "mark_all_pharmacy_notifications_read",
};

export const ACTIONS_PHARMACY_DASHBOARD_METRICS = {
  get_pharmacy_dashboard_metrics: "get_pharmacy_dashboard_metrics",
};

export const ACTIONS_DOCTOR_DASHBOARD_METRICS = {
  get_doctor_dashboard_metrics: "get_doctor_dashboard_metrics",
};

export const ACTIONS_GET_MEDICAL_ORDERS = {
  get_medical_orders: "get_medical_orders",
};

export const ACTIONS_GET_DOCTOR_CONSULTATION = {
  get_doctor_consultation: "get_doctor_consultation",
};

export const ACTIONS_GET_LAB_TESTS = {
  get_lab_tests: "get_lab_tests",
};

export const ACTIONS_GET_STATISTICS = {
  get_statistics: "get_statistics",
};

export const ACTION_INSURANCE_LOGIN = {
  insurance_login: "insurance_login",
  post_login: "post_insurance_login",
};

export const ACTIONS_INSURANCE_LOGOUT = {
  insurance_logout: "insurance_logout",
  logout: "logout_insurance",
};

export const ACTIONS_LOGIN = {
  login: "login",
  post_login: "post_login",
};

export const ACTIONS_LOGOUT = {
  logout: "logout",
};

export const ACTION_DOCTOR_PATIENT_COUNT = {
  update_doctor_patient_count: "update_doctor_patient_count",
};

export const ACTIONS_GET_PHARMACY_DASHBOARD_METRICS = {
  get_pharmacy_dashboard_metrics: "get_pharmacy_dashboard_metrics",
};

export const ACTIONS_PHARMACY_SALES_SUMMARY = {
  get_pharmacy_sales_summary: "get_pharmacy_sales_summary",
};

export const ACTIONS_PHARMACY_POPULAR_PRODUCTS = {
  get_pharmacy_popular_products: "get_pharmacy_popular_products",
};

export const ACTION_PHARMACY_WALLET = {
  fetch_pharmacy_wallet: "fetch_pharmacy_wallet",
  fetch_pharmacy_transaction_history: "fetch_pharmacy_transaction_history",
};

export const POST_RESET_PASSWORD = {
  reset_password: "reset_password",
  post_reset_password: "post_reset_password",
};

export const ACTIONS_UPlOAD_DOCTOR_DOC = {
  upload_doctor_doc: "upload_doctor_doc",
  update_doctor_doc: "update_doctor_doc",
};

export const ACTIONS_UPlOAD_PHARMACY_DOC = {
  upload_pharmacy_doc: "upload_pharmacy_doc",
};
